<highcharts-chart
  [Highcharts]="highcharts"
  [options]="chartOptions"
  style="width: 100%; height: 100%; display: block"
>
</highcharts-chart>
